

  <!-- Filter -->
  <div class="table-filter">
    <div class="row">

      <div class="col-md-12">
        <mat-form-field  class="search-form-field" floatLabel="never" >
          <input (keyup)="filterTable()" [(ngModel)]="searchKey" autocomplete="off" matInput placeholder="Search" />
          <button (click)="onSearchClear()" *ngIf="searchKey" arial-label="Clear" mat-button mat-icon-button matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

    </div>
  </div>
  <!-- end of Filter -->

  <div class="col-md-12 px-0 mat-elevation-z1 pb-3">
    <table [dataSource]="listData" class="table custom-table {{ tableCssClass }}" mat-table>

      <ng-container *ngFor="let tableColumn of tableColumns;let j = index">

        <ng-container matColumnDef="{{tableColumn.keyword}}">
          <th *matHeaderCellDef class="{{ tableColumn?.theadCellClass}}" mat-header-cell>
            {{tableColumn?.title}}
          </th>

          <td *matCellDef="let element" class="{{ tableColumn?.tbodyCellClass}}" mat-cell>
            <!--index cell-->
            <ng-container *ngIf="tableColumn.type === tableColumnType.index">
              {{j + 1 + myPaginator.pageIndex * myPaginator.pageSize}}
            </ng-container>
            <!--/ index cell-->

            <!--text cell-->
            <ng-container *ngIf="tableColumn.type == null">
              {{element[tableColumn.keyword]}}
            </ng-container>
            <!--/ text cell-->

            <!--html cell-->
            <ng-container *ngIf="tableColumn.type === tableColumnType.html">
              <span [innerHTML]="element[tableColumn.keyword]"></span>
            </ng-container>
            <!--/ html cell-->

            <!--number cell-->
            <ng-container *ngIf="tableColumn.type == tableColumnType.number">
              {{ element[tableColumn.keyword] | number}}
            </ng-container>
            <!--/ number cell-->

            <!--date cell-->
            <ng-container *ngIf="tableColumn.type === tableColumnType.date">
              {{ element[tableColumn.keyword] | date : tableColumn.dateFormat}}
            </ng-container>
            <!--/ date column-->

            <!--action cell-->
            <ng-container *ngIf="tableColumn?.isActionColumn">
              <ng-container [ngTemplateOutletContext]="{data : element}" [ngTemplateOutlet]="actions"></ng-container>
            </ng-container>
            <!--/ action cell-->

          </td>
        </ng-container>

      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
    <mat-paginator #myPaginator [pageSizeOptions]="pageSizeOptions" [pageSize]="10" showFirstLastButtons>
    </mat-paginator>
  </div>

